import type { FunctionComponent, ReactEventHandler } from 'react';

type DefaultImageProps = {
  src?: string;
  defaultImage: string;
  alt?: string;
};

const DefaultImage: FunctionComponent<DefaultImageProps> = ({
  src = null,
  defaultImage,
  alt = undefined,
}) => {
  const renderDefaultImage: ReactEventHandler<HTMLImageElement> = (e) => {
    e.currentTarget.src = defaultImage;
  };

  return <img src={src || defaultImage} onError={renderDefaultImage} alt={alt} />;
};

export default DefaultImage;
